import validate from '../../../services/reduxValidate.js'

export default function(data) {
  const options = {
    email: {
      email: {
        message: 'L\'adresse e-mail est invalide'
      },
      presence: true,
    },
  }

  return validate(data, options)
}